/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'present': {
    width: 54,
    height: 54,
    viewBox: '0 0 54 54',
    data: `<defs><clipPath id="svgicon_present_a"><path pid="0" d="M0 0h54v54H0z"/></clipPath></defs><g _fill="none" _stroke="currentColor" stroke-miterlimit="10" clip-path="url(#svgicon_present_a)"><path pid="1" d="M3.069 27.864V50.5h47.979V27.864M34.674 27.303h18.709l.117-9.3H.615l-.117 9.3h18.944"/><path pid="2" d="M30.626 50.5h-7.135V18.568h7.135zM23.842 7.951c3.593 2.773 3.366 8.925 3.366 8.925s-6.054 1.655-9.649-1.117-5.1-6.768-3.366-8.925 6.054-1.656 9.649 1.117z"/><path pid="3" d="M31.289 6.316c-4.2 3.239-3.823 10.556-3.823 10.556s7.18 2.07 11.376-1.169 5.909-7.963 3.822-10.556-7.179-2.068-11.375 1.169z"/></g>`
  }
})
/* tslint:enable */
